import { apiWithPrefix as api } from '../utils/api';

export class TeamService {
  static async getTeams(status = 'active') {
    const response = await api.get('/teams', {
      params: { status }
    });
    return response.data;
  }

  static async getCreateTeamData() {
    const response = await api.get('/createTeam');
    return response.data;
  }

  static async getEditTeamData(teamId) {
    const response = await api.get(`/editTeam/${teamId}`);
    return response.data;
  }

  static async createTeam(data) {
    const response = await api.post('/teams', data);
    return response.data;
  }

  static async updateTeam(teamId, data) {
    const response = await api.put(`/teams/${teamId}`, data);
    return response.data;
  }

  static async deleteTeam(teamId) {
    const response = await api.delete(`/teams/${teamId}`);
    return response.data;
  }
}

export default TeamService;
